import i18n from 'translations/i18n'
import { Item } from 'components/Filter/SelectedFilters'
import {
  CandidateFilterScreening,
  CandidateFilterScreeningAPI,
  JobApplicantScreeningRequest,
} from 'redux/ATS/jobApplicationInfo/jobApplicants/actions'

// Keys for candidate applications on JobView page
export const CANDIDATE_APPLICATION_FILTER_KEYS = [
  'candidate_source',
  'candidate_resume',
  'candidate_rating',
  'matching_score',
  'candidate_title',
  'country',
  'nationality',
  'candidate_screening',
] as const

// Keys for candidate application filter tags visible on JobView page
export const CANDIDATE_APPLICATION_FILTER_TAG_KEYS: Array<
  (typeof CANDIDATE_APPLICATION_FILTER_KEYS)[number]
> = ['candidate_source', 'candidate_resume', 'candidate_rating', 'matching_score']

// Keys for candidate sort filter on JobView page
export const CANDIDATE_APPLICATION_SORT_KEYS = [
  'create_by_desc',
  'create_by_asc',
  'candidate_match_desc',
] as const

export type CandidateApplicationSortKey = (typeof CANDIDATE_APPLICATION_SORT_KEYS)[number]

export const getCandidateApplicationSortKeys = (isScoringFeatureEnabled: boolean) => {
  if (isScoringFeatureEnabled) {
    return CANDIDATE_APPLICATION_SORT_KEYS
  }
  return CANDIDATE_APPLICATION_SORT_KEYS.filter((key) => key !== 'candidate_match_desc')
}

export const getCandidateApplicationFilterKeys = (isScoringFeatureEnabled: boolean) => {
  if (isScoringFeatureEnabled) {
    return CANDIDATE_APPLICATION_FILTER_KEYS
  }
  return CANDIDATE_APPLICATION_FILTER_KEYS.filter((key) => key !== 'matching_score')
}

export const getCandidateApplicationSortKeyLabel = (sortKey: CandidateApplicationSortKey) => {
  switch (sortKey) {
    case 'create_by_desc':
      return i18n.t('communication.new_to_old')
    case 'create_by_asc':
      return i18n.t('communication.old_to_new')
    case 'candidate_match_desc':
      return i18n.t('label.top_candidates')
    default:
      return i18n.t('communication.new_to_old')
  }
}
export const formatCandidateFilter = (
  candidateFilter: CandidateFilterScreeningAPI[],
): CandidateFilterScreening[] => {
  let id = 0
  return candidateFilter.map((question) => {
    return {
      id: question?.id,
      title: question?.title,
      options: question.options.map((option) => {
        id += 1
        return {
          id,
          title: option,
          options: [],
        }
      }),
    }
  })
}

export const formatScreeningQuestions = (
  selectedIds: number[],
  screeningQuestions: CandidateFilterScreening[],
): JobApplicantScreeningRequest[] => {
  const formattedScreeningQuestions: JobApplicantScreeningRequest[] = []
  screeningQuestions.forEach((question) => {
    const selectedOptions: string[] = []
    const optionIds = question.options.map((option) => option.id)
    selectedIds.forEach((id) => {
      if (optionIds.includes(id)) {
        const val = question.options.find((option) => option.id === id)?.title ?? ''
        selectedOptions.push(val)
      }
    })
    if (selectedOptions?.length) {
      formattedScreeningQuestions.push({
        id: question.id,
        title: question?.title,
        options: selectedOptions,
      })
    }
  })
  return formattedScreeningQuestions
}

export const formatScreeningTag = (
  tagIds: number[],
  screeningFilters: CandidateFilterScreening[],
): Item[] => {
  const screeningList: Item[] = []
  screeningFilters.forEach((screeningFilter) => {
    const filters = screeningFilter.options.filter((option) => tagIds?.includes(option.id))
    if (filters?.length) {
      filters.forEach((filter) => {
        screeningList.push({
          id: filter.id,
          name: filter?.title,
          keyType: 'candidate_screening',
        })
      })
    }
  })
  return screeningList
}
